export enum SexEnum {
  Male = "male",
  Female = "female"
}